<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="110px">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="所属车场" prop="spaceId">
                <el-select
                v-model="form.spaceId"
                disabled
                style="width:100%"
                placeholder="请选择所属车场"
                @change="spaceIdChange"
              >
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所属区域" prop="regionId">
                <el-select
                v-model="form.regionId"
                disabled
                style="width:100%"
                placeholder="请选择所属区域"

              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.spaceName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车位编号" prop="name">
                <el-input
                clearable
                disabled
                v-model="form.name"
                placeholder="车位编号"
                maxlength="30"
              ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车位面积" prop="area">
                <el-input
                clearable
                disabled
                v-model="form.area"
                placeholder="车位面积"
                maxlength="30"
              ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="子母车位" prop="isDouble">
                <el-select disabled v-model="form.isDouble" style="width:100%" placeholder="车位状态" clearable>
                <el-option
                  v-for="item in isDoubleData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车位性质" prop="parkingSpaceNature">
                <el-select disabled v-model="form.parkingSpaceNature" style="width:100%" placeholder="车位性质" clearable>
                  <el-option
                    v-for="item in parkingSpaceNatureDict"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车位状态" prop="spaceStatus">
                <el-select disabled v-model="form.spaceStatus" style="width:100%" placeholder="车位状态" clearable>
                <el-option
                  v-for="item in spaceStatusData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
              <el-form-item label="业主姓名" prop="personName">
                <el-input
                clearable
                disabled
                v-model="form.personName"
                placeholder="请输入业主姓名"
                maxlength="30"
              ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
              <el-form-item label="业主电话" prop="personPhone">
                <el-input
                disabled
                clearable
                v-model="form.personPhone"
                placeholder="请输入业主电话"
                maxlength="20"
              ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
              <el-form-item label="身份证号" prop="certNo">
                <el-input
                clearable
                disabled
                v-model="form.certNo"
                placeholder="请输入身份证号"
                maxlength="20"
              ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
              <el-form-item label="楼栋/单元" prop="buildingId">
                <el-select disabled v-model="form.buildingId" style="width:100%" placeholder="请选择楼栋/单元">
                <el-option
                  v-for="item in buildingList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
              <el-form-item label="房间名称" prop="roomId">
                <el-select  disabled v-model="form.roomId" style="width:100%" placeholder="请选择房间名称">
                <el-option
                  v-for="item in roomList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
              <el-form-item label="收费套餐" prop="feeRuleId">
                <el-select disabled v-model="form.feeRuleId" style="width:100%" placeholder="请选择收费套餐">
                <el-option
                  v-for="item in carRuleList"
                  :key="item.id"
                  :label="item.setmealName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="form.spaceStatus == 2">
            <el-form-item label="是否周期收费" prop="cycleFlag">
              <el-select
                v-model="form.cycleFlag"
                style="width: 100%"
                disabled
               placeholder="请选择是否周期收费"
              >
                <el-option
                  style="padding-left: 10px"
                  v-for="item in cycleFlagDictData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.spaceStatus == 2">
            <el-form-item label="收费周期数" prop="feeCycleNum">
              <el-input disabled placeholder="请输入收费周期数" v-model.number="form.feeCycleNum" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.spaceStatus == 2">
            <el-form-item label="收费周期" prop="feeCycleType">
              <el-select
                v-model="form.feeCycleType"
               disabled
                placeholder="请选择收费周期"
                style="width: 100%"
              >
                <el-option
                  style="padding-left: 10px"
                  v-for="item in feeCycleList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
            <el-col :span="12" v-if="form.spaceStatus ==2">
              <el-form-item label="出售日期" prop="soldDay">
                <el-date-picker
                v-model="form.soldDay"
                disabled
                type="date"
                placeholder="请选择出售日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="生效日期" prop="effectTime">
              <el-date-picker
                v-model="form.effectTime"
                disabled
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                placeholder="请选择生效日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
            <el-col :span="24" >
              <el-form-item  label="备注" prop="description">
                <el-input
                disabled
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入备注"
                  v-model="form.description"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>

            </el-col>
            <el-col :span="24" >
              <el-form-item  label="车辆绑定" >
                <avue-crud
                :option="carListOption"
                :data="form.carList"
                ref="carListData"
                >
      </avue-crud>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item  label="操作记录" >
                <avue-crud
                :option="operationListOption"
                :data="form.operateLogList"
                ref="operateLogListData"
                >
              </avue-crud>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </template>
  <script>

  import { getParkList,getRegionList ,getCarRuleList,getBuildingList,getRoomList,spaceDetail} from './index.js';
  export default {
    components: {  },
    props: {
      row: {
        default: {},
      },
      spaceId:{},
      model: {},
    },
    data() {
      return {
        cycleFlagDictData: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      feeCycleList: [
        {
          dictKey: 3,
          dictValue: '月',
        },
        {
          dictKey: 4,
          dictValue: '季',
        },
        {
          dictKey: 5,
          dictValue: '年',
        },
      ],
        spaceStatusData:[
            {
                dictKey:'1',
                dictValue:'空闲',
            },
            {
                dictKey:'2',
                dictValue:'已出售',
            },
          {
            dictKey:'3',
            dictValue:'已出租',
          },
        ],
        isDoubleData:[
            {
                dictKey:0,
                dictValue:'否',
            },
            {
                dictKey:1,
                dictValue:'是',
            },
        ],
        parkingSpaceNatureDict:[
          {
            dictKey: 1,
            dictValue:'车位',
          },
          {
            dictKey: 2,
            dictValue:'车库',
          },
        ],
        regionList:[],
        form: {
            spaceId:'',
             regionId:'',
          parkingSpaceNature: '',
              name :'',
              spaceStatus:'',
               isDouble:'',
                area:'',
                 personName:'',
                  personPhone :'',
                  roomId:'',
                  buildingId:'',
                   roomName:'',
                   feeRuleId:'',
                   certNo:'',
                    soldDay:'',
                     description:'',
                     cycleFlag:'',
        feeCycleNum:'',
        feeCycleType:''
        },
        formRules: {
          spaceId: [{ required: true, message: '所属车场不能为空', trigger: 'blur' }],
          regionId: [{ required: true, message: '所属区域不能为空', trigger: 'change' }],
          name: [{ required: true, message: '车位编号不能为空', trigger: 'change' }],
          spaceStatus: [{ required: true, message: '车位状态不能为空', trigger: 'blur' }],
          isDouble: [{ required: true, message: '子母车位不能为空', trigger: 'change' }],
          parkingSpaceNature: [{ required: true, message: '车位性质不能为空', trigger: 'change' }],
          personName  : [{ required: true, message: '业主姓名不能为空', trigger: 'change' }],
          personPhone: [{ required: true, message: '业主电话不能为空', trigger: 'change' }],
          roomId: [{ required: false, message: '房间名称不能为空', trigger: 'change' }],
          buildingId: [{ required: false, message: '楼栋/单元不能为空', trigger: 'change' }],
          feeRuleId: [{ required: false, message: '收费套餐不能为空', trigger: 'change' }],
          soldDay: [{ required: true, message: '出售日期不能为空', trigger: 'change' }],
          effectTime: [{ required: true, message: '生效日期不能为空', trigger: 'change' }],
        },
        tableHeight: '',
        spaceIdList:[],
        carRuleList:[],
        buildingList:[],
        roomList:[],
        carListOption:{
          refreshBtn:false,
          columnBtn:false,
          selection: false,
          select: false,
          index: true,
          indexLabel: '#',
          page: false,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '车牌号',
              prop: 'plateNumber',
            },
            {
              label: '车型大小',
              prop: 'bigOrSmallCar',
              type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: 'api/blade-system/dict/dictionary?code=car_type_v2',
            dataType: 'string',
            },
            {
              label: '主/副车',
              prop: 'isMainCar',
              type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicData:[
              {
                dictKey:'1',
                dictValue:'主'
              },
              {
                dictKey:'0',
                dictValue:'副'
              }
            ],
            dataType: 'string',
            },
            {
              label: '车主姓名',
              prop: 'personName',
            },
            {
              label: '车主电话',
              prop: 'personPhone',
            },
            {
              label: '公司/住址',
              prop: 'roomName',
            },
            {
              label: '登记时间',
              prop: 'createTime',
            },
          ],
        },
        operationListOption:{
          refreshBtn:false,
          columnBtn:false,
          selection: false,
          select: false,
          index: true,
          indexLabel: '#',
          page: false,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '操作类型',
              prop: 'operateType',
              type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicData:[
              {
                dictKey:'1',
                dictValue:'新增'
              },
              {
                dictKey:'2',
                dictValue:'修改'
              },
              {
                dictKey:'3',
                dictValue:'删除'
              },
              {
                dictKey:'4',
                dictValue:'缴费'
              },
              {
                dictKey:'5',
                dictValue:'绑定车辆'
              },
              {
                dictKey:'6',
                dictValue:'车位退费'
              },
              {
                dictKey:'7',
                dictValue:'申请断缴'
              },
              {
                dictKey:'8',
                dictValue:'审核'
              },
              {
                dictKey:'10',
                dictValue:'导入'
              },
              {
                dictKey:'99',
                dictValue:'其他'
              },
            ],
            dataType: 'string',
            },
            {
              label: '操作内容',
              prop: 'operateContent',
            },
            {

              prop: 'operatorName',
            },
            {
              label: '操作时间',
              prop: 'operateTime',
            },
          ],
        },
      };
    },
    created() {
      this.initData();
    },
    mounted() {
    },
    watch:{
    },
    methods: {
      initData() {
         getParkList().then((res) => {
          this.spaceIdList = res.data;
        });
        spaceDetail({id:this.row.id}).then(res=>{
            this.form = res.data
            getRegionList({
            spaceId:this.form.spaceId
            }).then((res) => {
                this.regionList = res.data
            })
            this.getCarRuleList()
            this.getBuildingList()
            this.getRoomList()
        })
        //字典下拉获取
      },
      getCarRuleList() {
        getCarRuleList({spaceId:this.form.spaceId,packageType:2}).then((res) => {
            this.carRuleList = res.data
          })
      },
      getBuildingList(){
        getBuildingList({spaceId:this.form.spaceId}).then((res) => {
            this.buildingList = res.data
          })
      },
      getRoomList(){
        getRoomList({buildingId:this.form.buildingId}).then((res) => {
            this.roomList = res.data
          })
      },
      saveRecord() {
        console.log(this.form);
        console.log(this.strategyList);
        let formRefValidate = false;
        console.log(this.$refs);
        this.$refs['formRef'].validate((valid) => {
          formRefValidate = valid;
        });
        let alarmListValide = true;
        this.strategyList.forEach((item, index) => {
          console.log(index);
          let str = 'alarmListRef' + index;
          this.$refs[str].validate((valid) => {
            if (valid) {
            } else {
              alarmListValide = false;
            }
          });
        });
        let alarmList1Valide = true;
        this.strategyList.forEach((item, index) => {
          let str = 'alarmList1Ref' + index;
          this.$refs[str].validate((valid) => {
            if (valid) {
            } else {
              alarmList1Valide = false;
            }
          });
        });
        let alarmList2Ref = true;
        this.strategyList.forEach((item, index) => {
          let str = 'alarmList2Ref' + index;
          this.$refs[str].validate((valid) => {
            if (valid) {
            } else {
              alarmList2Ref = false;
            }
          });
        });
        //校验所有的表单
        if (formRefValidate && alarmListValide && alarmList1Valide && alarmList2Ref) {
          this.form.strategyList = this.strategyList;
          if (this.model == 'add') {
            alarmRuleSave(this.form).then((res) => {
              this.$message({
                type: 'success',
                message: '新增成功!',
              });
              this.$emit('success');
            });
          } else {
            alarmRuleUpdate(this.form).then((res) => {
              this.$message({
                type: 'success',
                message: '编辑成功!',
              });
              this.$emit('success');
            });
          }
        }
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  </style>
